import { useRef, useEffect, useState } from 'react';
import WidgetAttributes from '../constants/widgetAttributes';
import { SportType, WidgetContextProps } from '../types';
import { isInStorybook } from '../utils';

// TODO: refactor
// Used as react-context for passing widgetId, widgetSport and widgetCuid
export default function useRootNodeRef() {
  const ref = useRef<HTMLDivElement>(null);
  const [widgetContext, setWidgetContext] = useState<WidgetContextProps | null>(null);

  useEffect(() => {
    if (ref.current && !isInStorybook()) {
      const el = ref.current;
      const widgetNode = (el.getRootNode() as ShadowRoot)?.host;

      if (!widgetNode) {
        // When widgets are provided as React components
        return;
      }

      setWidgetContext({
        widgetId: widgetNode.getAttribute(WidgetAttributes.WIDGET_ID) ?? '',
        widgetSport: (widgetNode.getAttribute(WidgetAttributes.WIDGET_SPORT) as SportType) ?? '',
        widgetCuid: widgetNode.getAttribute('data-id') ?? '', // TODO: this field is no longer necessary, remove it
      });
    }
  }, []);

  return { ref, widgetContext };
}
